export default __webpack_public_path__ + "d6d790eb054b73092b581fb785e4a018.png";